import getPlayfieldPosition from './playfieldPosition';
import './LaserShot.css';

function LaserShot({ bullet }) {
  return (
    <div
      className="bullet"
      style={getPlayfieldPosition(bullet.x, bullet.y)}
      aria-hidden="true"
    />
  );
}

export default LaserShot;
